import React from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "../web/pages/login/LoginPage";
import AuthComponent from "../web/components/AuthComponent";


import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { HashRouter, Route, Switch } from "react-router-dom";
import AdministrationPage from "./pages/administration/AdministrationPage";
import PackingLineTablePage from "./pages/line/PackingLineTablePage";
import PackingLineDetailsPage from "./pages/line/details/PackingLineDetailsPage";
import FastActingPartsTablePage from "./pages/fastActingPart/FastActingPartsTablePage";
import FormatPage from "./pages/format/FormatPage";
import FormatTablePage from "./pages/format/FormatTablePage";
import ManagementPage from "./pages/management/ManagementPage";
import CommonManagementActionPage from "./pages/management/actions/CommonManagementActionPage";
import FormatDeletedTablePage from "./pages/formatDeleted/FormatDeletedTablePage";
import FontTablePage from "./pages/font/FontTablePage";
import FontPage from "./pages/font/FontPage";
import FontInventoryPage from "./pages/font/FontInventoryPage";
import ProductionTablePage from "./pages/production/ProductionTablePage";
import StoragePlaceTablePage from "./pages/storagePlace/StoragePlaceTablePage";
import { useModels } from "./helpers/models";
import ProductionPage from "./pages/production/ProductionPage";
import LineSimulationPage from "./pages/simulation/LineSimulationPage";
import DashboardPage from "./pages/main/DashboardPage";
import PackingLineCreatePage from "./pages/line/create/PackingLineCreatePage";
import MachineModelTablePage from "./pages/machine-models/MachineModelTablePage";
import MachineModelDetailsPage from "./pages/machine-models/MachineModelDetailsPage";


const App = () => {

    const models = useModels();

    return (
        <>
            <HashRouter>
                <Switch>
                    <Route path="/login" component={LoginPage} />
                    {/*<Route path="/reset-password" component={ResetPassword} />*/}
                    <AuthComponent>
                        <Route exact path="/" component={DashboardPage} />
                        <Route exact path="/lines" component={PackingLineTablePage} />
                        <Route exact path="/fastActionParts" component={FastActingPartsTablePage} />
                        <Route exact path="/line/:id" component={PackingLineDetailsPage} />
                        <Route exact path="/line" component={PackingLineCreatePage} />
                        <Route exact path="/machine-models" component={MachineModelTablePage} />
                        <Route exact path="/machine-model/:id" component={MachineModelDetailsPage} />
                        <Route exact path="/format/:id" component={FormatPage} />
                        <Route exact path="/format" component={FormatPage} />
                        <Route exact path="/formats" component={FormatTablePage} />
                        <Route exact path="/formatsDeleted" component={FormatDeletedTablePage} />
                        <Route exact path="/admin" component={AdministrationPage} />
                        <Route exact path="/fonts" component={FontTablePage} />
                        <Route exact path="/management/:id" component={ManagementPage} />
                        <Route exact path="/font" component={FontPage} />
                        <Route exact path="/font/:machineId" component={FontPage} />
                        <Route exact path="/font/:machineId/inventory/:inventoryId" component={FontInventoryPage} />
                        <Route exact path="/production/:lineId" component={ProductionPage} />
                        <Route exact path="/production" component={ProductionTablePage} />
                        <Route exact path="/production/:lineId/simulation/:simulationId"
                            component={LineSimulationPage} />
                        <Route exact path="/production/:lineId/history/:productionId"
                            component={ProductionPage} />
                        <Route exact path={models.storagePlace.url} component={StoragePlaceTablePage} />
                        <Route exact path={`/management/:id/:actionType`} component={CommonManagementActionPage} />
                        <Route exact path={`/management/:id/:actionType/:actionId`}
                            component={CommonManagementActionPage} />
                        <Route exact path={`/management/:id/:actionType/:actionId/:actionSubtype`}
                            component={CommonManagementActionPage} />

                    </AuthComponent>
                    {/*<Route component={NotFoundPage} />*/}
                </Switch>
            </HashRouter>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}
export default App;